import Vue from "vue";
import bookingService from "./../../../services/booking";
import mixin from "../../../mixins/mixin";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import { VueTelInput } from "vue-tel-input";

export default {
  components: {
    VLayout: require("layouts/default/default.vue"),
    VPanel: require("components/panel/panel.vue"),
    VLoading: require("components/loading/loading.vue"),
    Datepicker,
    VueTelInput,
  },
  data() {
    return {
      en: en,
      fr: fr,
      content: "",
      permalink: "",
      loading: true,
      tenant_signature: "",
      auth: false,
      contract: {
        booking_id: "",
        rental_id: "",
        rental_name: "",
        address: "",
        checking: "",
        checkout: "",
        nbr_adults: "",
        total: "",
        nights_fees_total: "",
        taxes_fees_total: "",
        cleaning_fees_total: "",
        optional_fees_total: "",
        lessor_first_name: "",
        lessor_last_name: "",
        lessor_email: "",
        tenant_first_name: "",
        tenant_last_name: "",
        tenant_email: "",
        tenant_phone: "",
        request_id: "",
        verification_code: "",
        userCurrency: "€",
      },
      error: null,
      rental_deposit: 0,
      stateChecking: {
        disabled: {
          to: null,
          from: null,
        },
      },
      stateCheckout: {
        disabled: {
          to: null,
          from: null,
        },
      },
      isClickedOnSign: false,
      api_url: process.env.API_URL,
      countries: [],
      checkinDate: "",
      checkoutDate: "",
      activeStep: 1,
      smallLoading: false,
      isValidated: false,
      isContractPhoneNumberValid: true,
      lang: "fr",
    };
  },
  watch: {
    "contract.checking": function () {
      const vm = this;
      const newDate = new Date(vm.contract.checking);
      this.stateCheckout = {
        disabled: {
          to: new Date(newDate.setDate(newDate.getDate() + 1)),
          from: null,
        },
      };
    },
    "contract.checkout": function () {
      const vm = this;
      const newDate = new Date(vm.contract.checkout);
      this.stateChecking = {
        disabled: {
          to: null,
          from: new Date(newDate.setDate(newDate.getDate() - 1)),
        },
      };
    },
  },
  mixins: [mixin],
  async mounted() {
    const vm = this;
    vm.isClickedOnSign = false;
    vm.loading = true;
    // The style function
    $.fn.style = function (styleName, value, priority) {
      // DOM node
      const node = this.get(0);
      // Ensure we have a DOM node
      if (typeof node === "undefined") {
        return this;
      }
      // CSSStyleDeclaration
      const style = this.get(0).style;
      // Getter/Setter
      if (typeof styleName !== "undefined") {
        if (typeof value !== "undefined") {
          // Set style property
          priority = typeof priority !== "undefined" ? priority : "";
          style.setProperty(styleName, value, priority);
          return this;
        }
        // Get style property
        return style.getPropertyValue(styleName);
      }
      // Get CSSStyleDeclaration
      return style;
    };
    $("body").style("background-color", "#fff", "important");
    if (vm.$route.params.permalink) {
      vm.permalink = vm.$route.params.permalink;
      await vm.getContractByBookingId(vm.$route.params.permalink);
    } else {
      vm.loading = false;
    }

    $(document).ready(() => {
      $("#signature").jSignature({
        width: "70%",
        height: "200px",
      });
    });
  },
  methods: {
    async getContractByBookingId(permalink, sendAction = true) {
      await bookingService.getBookingByPermalik(permalink, this, sendAction);
      this.checkUserTimeZone(
        this,
        this.contract.checking,
        this.contract.checkout
      );
    },
    createBookingContract(contract = null) {
      const vm = this;
      // if (!vm.isContractPhoneNumberValid) {
      //   toastr.error(vm.$t("booking.detail.not_correct_format"));
      // }
      if (!vm.isClickedOnSign) {
        toastr.error("Veuillez signer le contrat");
      } else {
        vm.loading = true;
        const signature = $("#signature").jSignature("getData");

        const base64ImageContent = signature.replace(
          /^data:image\/(png|jpg);base64,/,
          ""
        );
        const data = {
          image: base64ImageContent,
          folder: "signatures",
        };
        bookingService.uploadContractSignatureImage(vm, data);
      }
    },
    updateBookingContract(contract = null) {
      const vm = this;
      // if (!vm.isContractPhoneNumberValid) {
      //   toastr.error(vm.$t("booking.detail.not_correct_format"));
      // }
      vm.closeModal("#contract-auth-modal");
      if (!vm.isClickedOnSign) {
        toastr.error("Veuillez signer le contrat");
      } else {
        vm.loading = true;
        const signature = $("#signature").jSignature("getData");

        const base64ImageContent = signature.replace(
          /^data:image\/(png|jpg);base64,/,
          ""
        );
        const data = {
          image: base64ImageContent,
          folder: "signatures",
        };
        bookingService.uploadContractSignatureImage(vm, data);
      }
    },
    clearSignature() {
      const vm = this;
      $("#signature").jSignature("reset");
      vm.isClickedOnSign = false;
    },
    toPrint() {
      window.print();
    },
    downloadPDF() {
      this.loading = true;
      bookingService.downloadContract(this, this.permalink);
    },
    clickedInSign() {
      const vm = this;
      vm.isClickedOnSign = true;
    },
    closeContractAuthModal() {
      this.closeModal("#contract-auth-modal");
      this.activeStep = 1;
      this.contract.verification_code = "";
      this.contract.request_id = "";
    },
    verifyContractAuth(step) {
      const vm = this;
      if (step === 1) {
        const data = {
          phone_number: vm.contract.tenant_phone,
          rental_name: vm.contract.rental_name,
        };
        vm.smallLoading = true;
        bookingService.sendContractAuthVerificationCode(vm, data);
      } else if (step === 2) {
        const data = {
          code: parseInt(vm.contract.verification_code),
          request_id: vm.contract.request_id,
        };
        vm.smallLoading = true;
        bookingService.checkContractAuthVerificationCode(vm, data);
      }
    },
    validateBookingContractForCreate(contract) {
      const vm = this;
      // if (!vm.isContractPhoneNumberValid) {
      //   toastr.error(vm.$t("booking.detail.not_correct_format"));
      // }
      if (!vm.isClickedOnSign) {
        toastr.error("Veuillez signer le contrat");
      } else {
        bookingService.validateBookingContractCreate(contract, vm);
      }
    },
    validateBookingContractForUpdate(contract) {
      const vm = this;
      // if (!vm.isContractPhoneNumberValid) {
      //   toastr.error(vm.$t("booking.detail.not_correct_format"));
      // }
      if (!vm.isClickedOnSign) {
        toastr.error("Veuillez signer le contrat");
      } else {
        bookingService.validateBookingContractUpdate(contract, vm);
      }
    },
    sendCodeAgain() {
      const vm = this;
      const data = {
        phone_number: vm.contract.tenant_phone,
        rental_name: vm.contract.rental_name,
      };
      vm.smallLoading = true;
      bookingService.sendContractAuthVerificationCode(vm, data);
    },
    validatePhoneNumber(event) {
      if (event.isValid) {
        this.contract.tenant_phone = event.number.international;
        this.isContractPhoneNumberValid = true;
      } else {
        this.isContractPhoneNumberValid = false;
      }
    },
    getDatePickerLang() {
      const availableLanguages = ["en", "es", "fr"];
      if (this.contract.tenant_country) {
        const guestCountry = this.contract.tenant_country.toLowerCase();
        if (availableLanguages.includes(guestCountry)) {
          this.lang = guestCountry;
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/bookings/contract/contract.js